// truncate.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncateText implements PipeTransform {
  transform(value: string, limit: number = 140): string {
    if (!value) return '';

    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
}
